export default __webpack_public_path__ + "navigation-examples-offline-regions-960-fa17d6bbd204397f438ade628793ce09.webp";